import {Box, Button, Sheet, Stack, Typography} from "@mui/joy";
import {version} from "./version.ts";
import {faExclamationTriangle} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useToaster} from "./bomb/bomb.tsx";
import {useZrpcVersionInfo} from "./tq/tqx.tsx";

export function VersionFooter() {
    const baseurl = import.meta.env.BASE_URL;
    const vendor = baseurl.substring(1);
    const toaster = useToaster();
    const {data: zrpcVersionInfo} = useZrpcVersionInfo();

    return <footer style={{textAlign: "center"}}>
        <Stack direction="row" display="flex">
            <Box sx={{flex: 1}}/>
            <Stack direction="row" sx={{alignItems: "center"}}>
                <Button variant="plain" sx={{px: 2}} onClick={() => {
                    toaster.raise({
                        decos: {color: "success", variant: "soft", autoHideDuration: null},
                        children: `zrpc: ${JSON.stringify(zrpcVersionInfo)}`
                    })
                }}>{version.branch} {version.commit}</Button>

                {version.snapshot ?
                    <Sheet color="danger" invertedColors variant="soft">
                        <Typography level="body-md" sx={{px: 2}}>
                            <FontAwesomeIcon icon={faExclamationTriangle}/> SNAPSHOT
                        </Typography>
                    </Sheet>
                    : null}

                {vendor !== "/"
                    ? <Typography sx={{px: 2}}>{vendor}</Typography>
                    : null}
            </Stack>
            <Box sx={{flex: 1}}/>
        </Stack>

    </footer>
}
